"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var table_style = __importStar(require("../Table.module.scss"));
var button_style = __importStar(require("@components/Buttons/Button.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var mechanicsSlice_1 = require("@store/slices/mechanicsSlice");
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var tableTranslator_1 = require("../localisation/tableTranslator");
var icons_1 = require("@assets/icons");
var mechanicsAPI_1 = require("@services/mechanicsAPI");
var modalSlice_1 = require("@store/slices/modalSlice");
var react_redux_2 = require("react-redux");
var loaderSlice_1 = require("@store/slices/loaderSlice");
var modalSlice_2 = require("@store/slices/modalSlice");
var withConfirmationModal_1 = __importDefault(require("@components/_hoc/withConfirmationModal"));
function MechanicsTable(_a) {
    var group = _a.group, showConfirmationModal = _a.showConfirmationModal;
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = tableTranslator_1.tableTranslator[currentLang];
    var gddId = (0, react_redux_2.useSelector)(function (state) { return state.gddSlice.gdd; }).id;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(true), isExpanded = _b[0], setExpanded = _b[1];
    function handleMechanicDelete(id) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, mechanicsAPI_1.deleteMechanicAPI)(id)];
                    case 1:
                        res = _a.sent();
                        if (res.data.success) {
                            dispatch((0, mechanicsSlice_1.deleteMechanic)(id));
                            return [2 /*return*/];
                        }
                        dispatch((0, modalSlice_2.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: res.data.message }));
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_2.showModal)({
                            activeModal: modalSlice_1.ActiveModal.Info,
                            text: error_1,
                        }));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function handleDeleteButtonClick(mechanic) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!showConfirmationModal)
                    return [2 /*return*/];
                showConfirmationModal(loc.onDeleteMessage(mechanic.name), function () {
                    return handleMechanicDelete(mechanic.id);
                });
                return [2 /*return*/];
            });
        });
    }
    function handleCreateDuplicate(mechanic) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch((0, loaderSlice_1.setLoading)(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, mechanicsAPI_1.createMechanicAPI)(__assign(__assign({}, mechanic), { gdd_id: gddId }))];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            dispatch((0, mechanicsSlice_1.addMechanic)(res.mechanic));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        dispatch((0, modalSlice_2.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: error_2 }));
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch((0, loaderSlice_1.setLoading)(false));
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    if (group.mechanics.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: table_style.table_wrapper, children: [(0, jsx_runtime_1.jsx)("h3", { className: table_style.section_header, children: group.type.type.toUpperCase() }), " ", (0, jsx_runtime_1.jsx)("button", { className: "".concat(button_style.create_btn, " ").concat(table_style.section_toggle_button), onClick: function () { return setExpanded(!isExpanded); }, children: isExpanded ? icons_1.icons.up : icons_1.icons.down }), isExpanded ? ((0, jsx_runtime_1.jsxs)("table", { className: table_style.table, children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: loc.nameHeader }), (0, jsx_runtime_1.jsx)("th", { children: loc.actionHeader })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: group.mechanics.map(function (mechanic) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: mechanic.name }), (0, jsx_runtime_1.jsxs)("td", { className: table_style.actions_row, children: [(0, jsx_runtime_1.jsx)("button", { className: button_style.create_btn, onClick: function () { return navigate("".concat(mechanic.id)); }, children: icons_1.icons.edit }), (0, jsx_runtime_1.jsx)("button", { className: button_style.cancel_btn, onClick: function () { return handleCreateDuplicate(mechanic); }, children: icons_1.icons.copy }), (0, jsx_runtime_1.jsx)("button", { className: button_style.delete_btn, onClick: function () {
                                                handleDeleteButtonClick(mechanic);
                                            }, children: icons_1.icons.delete })] })] }, mechanic.id)); }) })] })) : null] }));
}
exports.default = (0, withConfirmationModal_1.default)(MechanicsTable);
